import { styled, Tab as MuiTab, TabProps as MuiTabProps } from "@mui/material";

const StyledTab = styled(MuiTab)(({ theme }) => {
  return {
    "&.Mui-selected": {
      color: theme.palette.text.primary,
      fontWeight: "600",
      borderBottom: `0.3rem solid #FFD400`,
    },
  };
});

type TabProps = MuiTabProps;

export const Tab: React.FC<TabProps> = ({ ...props }) => {
  return <StyledTab {...props} />;
};

export default Tab;
